module.exports = __webpack_public_path__ + "img/404.8af05b09.svg";